import dayjs from 'dayjs';

export const formatDateTime = (value: string): string =>
  dayjs(value).format('DD.MM.YYYY HH:mm');
